import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCheckMark24pxGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <polygon
        points="9.707 14.293 19 5 20.414 6.414 9.707 17.121 4 11.414 5.414 10"
        fill={fillColor}
      />
    </g>
  );
};

export const IconCheckMark24pxSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconCheckMark24pxGroup {...props} />
    </svg>
  );
};
